import React from 'react';
import { useAuth } from '../../../../contexts/AuthContext';
import { DateRange } from '../DateRange/DateRange';

interface WelcomeBannerProps {
  startDate: string;
  endDate: string;
}

export const WelcomeBanner: React.FC<WelcomeBannerProps> = ({ startDate, endDate }) => {
  const { userData } = useAuth();
  const fullName = [userData?.firstName, userData?.lastName].filter(Boolean).join(' ');

  return (
    <div className="welcome-banner">
      <div className="welcome-content">
        <h2>
          👋 Hey there,
          <br />
          {fullName || 'Challenger'}!
        </h2>
        <p>
          Every hour you work adds to your score — so keep it going! Compete, climb the leaderboard,
          and good luck out there! 🚀💼
        </p>
      </div>
      <DateRange startDate={startDate} endDate={endDate} />
    </div>
  );
};
